import React, { Component } from "react";
import About from "./About";
import Header from "./Header";
import Services from "./Services";
import Footer from "./Footer";

class Marketing extends Component {
  render() {
    return (
      <div>
        <Header />
        <About />
        <Services />
        <Footer />
      </div>
    );
  }
}

export default Marketing;
